import BeautyInsiderModules from 'components/Content/BeautyInsider/BeautyInsiderModules/BeautyInsiderModules';
import { withBeautyInsiderModulesProps } from 'viewModel/content/BeautyInsider/BeautyInsiderModules/withBeautyInsiderModulesProps';

export default withBeautyInsiderModulesProps(BeautyInsiderModules);
